/* @flow */
export { default as ServicesPageChrome } from './ServicesPageChrome';
export { default as StoreDeliveryPage } from './StoreDeliveryPage';
export { default as SmallMovesPage } from './SmallMovesPage';
export { default as CraigslistDeliveryPage } from './CraigslistDeliveryPage';
export { default as DonationsPage } from './DonationsPage';
export { default as JunkRemovalPage } from './JunkRemovalPage';
export { default as StorageMovesPage } from './StorageMovesPage';



// WEBPACK FOOTER //
// ./src/ui/pages/ServicesPage/index.js